import CursistFormStepper from "@/components/forms/students/StudentFormStepper"
import { Scoped } from "@/components/forms/students/UseStudentFormStepper"
import ScreenWrapper from "@/components/ScreenWrapper"
import { useStudentCreateStore } from "@/stores/useStudentCreateStore"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute } from "@tanstack/react-router"
import { useMemo } from "react"

export const Route = createFileRoute("/beheer/cursisten/aanmaken")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("create", "students"),
})

function RouteComponent() {
  const { currentStep, personalStepData, projectStepData, enrollmentFlow } =
    useStudentCreateStore()

  const initialStep = useMemo(() => {
    if (!projectStepData) {
      return "contract" as const
    }

    if (!personalStepData) {
      return "personal" as const
    }

    if (enrollmentFlow === "without-intake") {
      return currentStep === "contact" || currentStep === "leveldetermination"
        ? currentStep
        : "contact"
    }

    return "personal" as const
  }, [currentStep, personalStepData, projectStepData, enrollmentFlow])

  return (
    <ScreenWrapper showManagementMenu>
      <Scoped initialStep={initialStep}>
        <CursistFormStepper />
      </Scoped>
    </ScreenWrapper>
  )
}
